import React from "react";
// import { useSearchParams } from "react-router-dom";
import { mockFlights } from "../data/mockFlights";
import FlightCard from "../components/FlightCard";
import SearchForm from "../components/SearchForm";
import Header from "../components/Header";

function SearchResults() {
  //   const [searchParams] = useSearchParams();

  //   Get search parameters
  //   const origin = searchParams.get("origin") || "";
  //   const destination = searchParams.get("destination") || "";
  //   const outbound = searchParams.get("outbound") || "";
  //   const returnDate = searchParams.get("return") || "";
  //   const adults = parseInt(searchParams.get("adults") || "1");
  //   const children = parseInt(searchParams.get("children") || "0");
  //   const infants = parseInt(searchParams.get("infants") || "0");
  //   const classType = searchParams.get("class") || "economy";
  //   const currency = searchParams.get("currency") || "GBP";

  return (
    <div className="min-h-screen bg-slate-800">
      <Header isTransparent={true} />
      <div className="container mx-auto py-8">
        <div className="mb-8">
          <SearchForm />
        </div>

        <div className="space-y-4 bg-gray-100 p-4">
          {mockFlights.map((flight) => (
            <FlightCard key={flight.id} flight={flight} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SearchResults;
